const genreMap: Record<string, string> = {
  'Music': 'Music',
  'Folk': 'Folk',
  'Bass / DnB': 'Electronic',
  'Market': 'Market',
  'Community': 'Community',
  'Spoken Word': 'Stand-up',
}

export function getEventListParams(
  activeFilter: string,
): { kind: string } | { genre: string } | undefined {
  if (activeFilter === 'All') return undefined
  if (activeFilter === 'Music') return { kind: 'music' }
  return { genre: genreMap[activeFilter] }
}
